import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";

// Friendly, on-brand empty state. Optional CTA for admins/team; informational for partners.
export function EmptyState({ icon: Icon, title, description, actionLabel, onAction, actionTo, footer, testid }) {
  const navigate = useNavigate();
  const handle = () => (onAction ? onAction() : actionTo && navigate(actionTo));
  return (
    <div
      data-testid={testid}
      className="flex flex-col items-center text-center py-12 px-6 rounded-3xl border border-dashed border-[var(--brand-navy)]/15 bg-white/60 animate-fade-up"
    >
      {Icon && (
        <div className="h-16 w-16 rounded-2xl bg-[var(--tenant-accent)]/12 flex items-center justify-center mb-4">
          <Icon className="h-7 w-7 accent-text" />
        </div>
      )}
      <h3 className="font-heading font-bold text-xl text-[var(--brand-navy)]">{title}</h3>
      {description && <p className="text-sm text-muted-foreground mt-1.5 max-w-xs leading-relaxed">{description}</p>}
      {actionLabel && (
        <Button
          data-testid={testid ? `${testid}-action` : undefined}
          onClick={handle}
          className="rounded-full accent-bg text-white h-11 px-6 mt-5 hover:opacity-90 transition-opacity"
        >
          {actionLabel}
        </Button>
      )}
      {footer && <div className="mt-3">{footer}</div>}
    </div>
  );
}

export default EmptyState;
